import React from 'react';
import styled from 'styled-components';
import RighArrow from '~/components/shared/RightArrow/RightArrow';
import {
  FontWeights,
  Typography,
} from '~/components/shared/Typography/Typography';
import useTranslate from '~/hooks/useTranslate';

const SinglePaymentMethodContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 0.25em;
  margin-bottom: 1em;
  padding: 0em 0em 0em 1em;
  border: 2px solid #f2f3f0;
  cursor: pointer;
  @media (orientation: landscape) {
    padding: 0em 0em 0em 2em;
  }
`;

const SinglePaymentMethhodTitleHolder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  margin: 0rem 0rem;
  align-items: center;
`;

export const MostPopuarHolder = styled.div`
  background-color: #1387ac10;
  display: flex;
  aligin-items: center;
  justify-content: center;
  border-bottom-left-radius: 1rem;
  margin-top: -1rem;
  padding: 1rem 2rem;
`;

interface Props {
  header: string;
  text: string;
  popular?: boolean;
}

const SinglePaymentMethod: React.FC<Props> = ({ header, text, popular }) => {
  const transate = useTranslate();
  return (
    <SinglePaymentMethodContainer>
      <SinglePaymentMethhodTitleHolder>
        <Typography
          fontSize={1}
          fontWeight={FontWeights.Thick}
          style={{ paddingTop: '1.3em', marginTop: '0.2em' }}
          noMargin
        >
          {header}
        </Typography>
        {popular && (
          <MostPopuarHolder>
            <Typography color="#1387ac" fontSize={0.7}>
              Most Popular
            </Typography>
          </MostPopuarHolder>
        )}
      </SinglePaymentMethhodTitleHolder>

      <SinglePaymentMethhodTitleHolder>
        <Typography fontSize={0.9} lineHeight={1.5} color="#757575">
          {text}
        </Typography>
        <RighArrow color="#214749" />
      </SinglePaymentMethhodTitleHolder>

      <SinglePaymentMethhodTitleHolder>
        <Typography fontSize={1} />
        <Typography fontSize={1} />
      </SinglePaymentMethhodTitleHolder>
    </SinglePaymentMethodContainer>
  );
};

export default SinglePaymentMethod;
